import { type SettlementItem } from "@/types/tile";

/** Static settlement list (no `buildings` import — breaks useEvent ↔ settlements cycles). */

export const settlementNames = new Map<number, SettlementItem>([
	[1, { name: "Capital", x: 512, y: 512 }],
	[2, { name: "Tradesmeet", x: 523, y: 566 }],
	[3, { name: "Aber's Rest", x: 578, y: 496 }],
	[4, { name: "Ellbacher", x: 512, y: 505 }],
	[5, { name: "Weissenholme", x: 522, y: 516 }],
	[6, { name: "Langensvaal", x: 524, y: 503 }],
	[7, { name: "Kärntobel", x: 504, y: 515 }],
	[8, { name: "Darazim", x: 390, y: 412 }],
	[9, { name: "Vierbrod", x: 422, y: 389 }],
	[10, { name: "Untervald", x: 468, y: 395 }],
	[11, { name: "Praznovar", x: 439, y: 420 }],
	[12, { name: "Miravonne", x: 448, y: 439 }],
	[13, { name: "Iserfeld", x: 463, y: 458 }],
	[14, { name: "Jasirah", x: 434, y: 546 }],
	[15, { name: "Lorencarno", x: 412, y: 450 }],
	[16, { name: "Würzlingen", x: 395, y: 488 }],
	[17, { name: "Schlossbrück", x: 432, y: 496 }],
	[18, { name: "Wandlingen", x: 471, y: 505 }],
	[19, { name: "Falkengraaf", x: 564, y: 397 }],
	[20, { name: "Ulaytah", x: 481, y: 475 }],
	[21, { name: "Rilaad", x: 462, y: 551 }],
	[22, { name: "Machtfels", x: 490, y: 436 }],
	[23, { name: "Montedoro", x: 519, y: 416 }],
	[24, { name: "Drosselmeer", x: 611, y: 391 }],
	[25, { name: "Chalwonik", x: 587, y: 411 }],
	[26, { name: "Frauenheim", x: 625, y: 417 }],
	[27, { name: "Zelevich", x: 596, y: 436 }],
	[28, { name: "Katenfels", x: 547, y: 433 }],
	[29, { name: "Eikenberg", x: 518, y: 456 }],
	[30, { name: "Pepeesko", x: 517, y: 479 }],
	[31, { name: "Schreibdorf", x: 544, y: 472 }],
	[32, { name: "Lorvenstadt", x: 579, y: 459 }],
	[33, { name: "Halstavik", x: 629, y: 477 }],
	[34, { name: "Niedervaal", x: 630, y: 508 }],
	[35, { name: "Vollbrück", x: 603, y: 528 }],
	[36, { name: "Isenbourg", x: 559, y: 527 }],
	[37, { name: "Drevesko", x: 554, y: 515 }],
	[38, { name: "Khalbara", x: 430, y: 598 }],
	[39, { name: "Verdovaal", x: 479, y: 534 }],
	[40, { name: "Fayruzabad", x: 500, y: 550 }],
	[41, { name: "Rosvanya", x: 518, y: 536 }],
	[42, { name: "Helmingford", x: 538, y: 538 }],
	[43, { name: "Felsbach", x: 570, y: 543 }],
	[44, { name: "Makuvera", x: 623, y: 549 }],
	[45, { name: "Krezvyr", x: 490, y: 590 }],
	[46, { name: "Saqqarah", x: 452, y: 581 }],
	[47, { name: "Preussenbach", x: 629, y: 629 }],
	[48, { name: "Torgensbrau", x: 594, y: 631 }],
	[49, { name: "Gretschnov", x: 606, y: 602 }],
	[50, { name: "Ischmara", x: 585, y: 574 }],
	[51, { name: "Pontelione", x: 525, y: 600 }],
	[52, { name: "Rothburg", x: 577, y: 604 }],
	[53, { name: "Gryznovo", x: 561, y: 588 }],
	[54, { name: "Kubsonberg", x: 407, y: 618 }],
	[55, { name: "Moravcovo", x: 412, y: 622 }],
	[56, { name: "Dralensby", x: 489, y: 504 }],
	[57, { name: "Eshinomura", x: 537, y: 491 }],
	[58, { name: "Quirlitz", x: 545, y: 574 }],
	[59, { name: "Nordburg", x: 501, y: 528 }],
	[60, { name: "Czardova", x: 468, y: 485 }],
	[61, { name: "Bressonne", x: 541, y: 526 }],
	[62, { name: "Baisanji", x: 508, y: 490 }],
	[63, { name: "Ildebourg", x: 558, y: 492 }],
	[64, { name: "Pryzgrad", x: 486, y: 488 }],
	[65, { name: "Gomara", x: 540, y: 552 }],
	[66, { name: "Lamtarim", x: 479, y: 516 }],
	[67, { name: "Djenkoura", x: 438, y: 471 }],
	[68, { name: "Basilheim", x: 563, y: 446 }],
	[69, { name: "Alvercia", x: 481, y: 566 }],
	[70, { name: "Zacharovce", x: 583, y: 480 }],
	[71, { name: "Zennorvik", x: 500, y: 497 }],
	[72, { name: "Droslavik", x: 514, y: 526 }],
	[73, { name: "Czerdyna", x: 456, y: 503 }],
	[74, { name: "Kreznovor", x: 544, y: 505 }],
	[75, { name: "Monstia", x: 509, y: 584 }],
	[76, { name: "Franzstadt", x: 455, y: 476 }],
	[77, { name: "Elandoro", x: 562, y: 572 }],
	[78, { name: "Cattolica", x: 532, y: 386 }],
	[79, { name: "Hassouna", x: 488, y: 456 }],
	[80, { name: "Zürtwach", x: 450, y: 524 }],
	[81, { name: "Brennwald", x: 421, y: 434 }],
	[82, { name: "Brastovia", x: 589, y: 551 }],
	[83, { name: "Grenshavn", x: 465, y: 422 }],
	[84, { name: "Trovenstein", x: 593, y: 513 }],
	[85, { name: "Wormsdorf", x: 534, y: 517 }],
	[86, { name: "Silvenstadt", x: 381, y: 383 }],
	[87, { name: "Xarnaveir", x: 437, y: 362 }],
	[88, { name: "Pzenag", x: 483, y: 371 }],
	[89, { name: "Borghesia", x: 519, y: 372 }],
	[90, { name: "Schattenfels", x: 552, y: 363 }],
	[91, { name: "Inakayama", x: 587, y: 363 }],
	[92, { name: "Jurissau", x: 642, y: 376 }],
	[93, { name: "Zumurrah", x: 651, y: 382 }],
	[94, { name: "Oberlind", x: 657, y: 408 }],
	[95, { name: "Quellicourt", x: 646, y: 449 }],
	[96, { name: "Carinthal", x: 654, y: 492 }],
	[97, { name: "Wartenfels", x: 657, y: 543 }],
	[98, { name: "Nosterbrück", x: 642, y: 596 }],
	[99, { name: "Thornswijk", x: 652, y: 649 }],
	[100, { name: "Herzograd", x: 634, y: 644 }],
	[101, { name: "Garubani", x: 584, y: 649 }],
	[102, { name: "Zanubiya", x: 532, y: 651 }],
	[103, { name: "Moltenhagen", x: 487, y: 650 }],
	[104, { name: "Léonvaux", x: 435, y: 651 }],
	[105, { name: "Gronvik", x: 400, y: 658 }],
	[106, { name: "Aronstet", x: 369, y: 634 }],
	[107, { name: "Herzenwald", x: 364, y: 595 }],
	[108, { name: "Blackhall", x: 375, y: 546 }],
	[109, { name: "Elmschatten", x: 363, y: 489 }],
	[110, { name: "Olfenwald", x: 368, y: 444 }],
	[111, { name: "Yaromorsk", x: 402, y: 373 }],
	[112, { name: "Dravenholm", x: 569, y: 381 }],
	[113, { name: "Khorijin", x: 510, y: 637 }],
	[114, { name: "Cruxvenna", x: 370, y: 513 }],
	[115, { name: "Varneløse", x: 645, y: 566 }],
	[116, { name: "Emilov", x: 350, y: 653 }],
	[117, { name: "Oravan", x: 350, y: 602 }],
	[118, { name: "Glynshavn", x: 340, y: 565 }],
	[119, { name: "Heiligenfurt", x: 336, y: 541 }],
	[120, { name: "Prespurcina", x: 346, y: 530 }],
	[121, { name: "Hollvaar", x: 348, y: 497 }],
	[122, { name: "Denisee", x: 340, y: 443 }],
	[123, { name: "Zigenhavn", x: 346, y: 424 }],
	[124, { name: "Daigahara", x: 356, y: 395 }],
	[125, { name: "Findlver", x: 336, y: 365 }],
	[126, { name: "Matildovo", x: 668, y: 639 }],
	[127, { name: "Novareich", x: 673, y: 585 }],
	[128, { name: "Zarovik", x: 665, y: 553 }],
	[129, { name: "Ulvenstein", x: 680, y: 527 }],
	[130, { name: "Elisse", x: 667, y: 505 }],
	[131, { name: "Mikhaelson", x: 678, y: 482 }],
	[132, { name: "Axefjel", x: 680, y: 457 }],
	[133, { name: "Drakendorf", x: 664, y: 435 }],
	[134, { name: "Monsegna", x: 681, y: 401 }],
	[135, { name: "Ulmstedt", x: 666, y: 372 }],
	[136, { name: "Anariel", x: 631, y: 338 }],
	[137, { name: "Vladigrad", x: 605, y: 345 }],
	[138, { name: "Klasvik", x: 564, y: 355 }],
	[139, { name: "Jorvasil", x: 544, y: 339 }],
	[140, { name: "Islovna", x: 498, y: 356 }],
	[141, { name: "Bruxhaven", x: 442, y: 336 }],
	[142, { name: "Tarnovo", x: 413, y: 343 }],
	[143, { name: "Elsenvik", x: 376, y: 353 }],
	[144, { name: "Welsgraaf", x: 370, y: 338 }],
	[145, { name: "Flussburg", x: 342, y: 340 }],
	[146, { name: "Jurlstad", x: 359, y: 681 }],
	[147, { name: "Lingzhao", x: 366, y: 663 }],
	[148, { name: "Arnshoff", x: 395, y: 675 }],
	[149, { name: "Landskrona", x: 470, y: 663 }],
	[150, { name: "Ravensburg", x: 477, y: 674 }],
	[151, { name: "Valendrez", x: 529, y: 673 }],
	[152, { name: "Prazthoff", x: 557, y: 681 }],
	[153, { name: "Umbatari", x: 610, y: 673 }],
	[154, { name: "Quedrina", x: 649, y: 668 }],
	[155, { name: "Zvalograd", x: 670, y: 682 }],
]);
